"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.quantityThresholdValidatorErrorKeys = void 0;
const LocalizedThresholdValidatorFn_1 = require("./LocalizedThresholdValidatorFn");
/**
 * An Array of the Quantity Threshold Validator Error Keys.
 */
exports.quantityThresholdValidatorErrorKeys = LocalizedThresholdValidatorFn_1.localizedThresholdValidatorErrorKeys;
//# sourceMappingURL=QuantityThresholdValidatorFn.js.map